import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'app-set-phonenumber-form',
    templateUrl: './set-phonenumber-form.component.html',
    styleUrls: ['./set-phonenumber-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class SetPhonenumberFormComponent implements OnInit, AfterViewInit, OnDestroy {
  static readonly componentName = 'SetPhonenumberFormComponent';
  
  @Input() isSubmitting = false;
  @Input() sysText: any;
  @Input() page: string;  
  @Input() showNumberField: Subject<boolean>;
  @Output() goBack = new EventEmitter();
  @Output() resendCode = new EventEmitter();
  @Output() formSubmit = new EventEmitter<FormGroup>();
  @Output() setPhoneNumber = new EventEmitter<string>();
  @ViewChild('otpInput') otpInput: ElementRef<HTMLInputElement>;
  @ViewChild('phoneInput') phoneInput: ElementRef<HTMLInputElement>;
  phoneForm: FormGroup;

  get otp(): FormControl {
    return this.phoneForm.get('otp') as FormControl;
  }

  get phonenumber(): FormControl {
    return this.phoneForm.get('phonenumber') as FormControl;
  }

  private destroy$: Subject<void> = new Subject<void>();

  constructor(private fb: FormBuilder) { }

  ngOnInit(): void {
    this.phoneForm = this.fb.group({
      otp: '',
      phonenumber: ''
    });
  }

  ngAfterViewInit(): void {
    // this form replaces the set password form, and swaps between its code and number fields,
    // so focus goes to whichever field is showing instead of being lost with the swapped-out part
    this.focusField(false);

    this.showNumberField
      .pipe(takeUntil(this.destroy$))
      .subscribe((showNumber) => this.focusField(showNumber));
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

  onResend(): void {
    this.resendCode.emit();
  }

  onShowSetPhoneNumber(): void {    
    this.showNumberField.next(true)   
  }

  onHideSetPhoneNumber(): void {    
    this.showNumberField.next(false)   
  }

  onSetNumber(): void {    
    this.setPhoneNumber.emit(this.phoneForm.value.phonenumber)
  }

  onGoBack(): void {
    this.goBack.emit();
  }

  onSubmit(): void {
    this.formSubmit.emit(this.phoneForm);
  }

  private focusField(showNumber: boolean): void {
    setTimeout(() => (showNumber ? this.phoneInput : this.otpInput)?.nativeElement.focus());
  }
}